<template>
    <!-- Admit button (shown when member hasn't visited today) -->
    <button v-if="!member.visitedToday"
            type="button"
            class="btn btn-success btn-block btn--inline-flex admit-member-btn"
            :disabled="member.redemptionActionInProgress || !membership.canBeRedeemedRightNow()"
            @click="$emit('toggle-visit')">
        <i v-if="member.redemptionActionInProgress"
           class="fa-solid fa-spinner fa-spin"></i>
        <i v-else
           class="fa-solid fa-arrow-right-to-bracket"></i>
        <span>{{ l('MEMBERSHIP_DETAILS.ADMIT_MEMBER_BTN') }}</span>
    </button>

    <!-- Un-admit button (shown when member has visited today) -->
    <button v-if="member.visitedToday"
            type="button"
            class="btn btn-default btn-block btn--inline-flex unadmit-member-btn"
            :disabled="member.redemptionActionInProgress || !membership.canBeRedeemedRightNow()"
            @click="$emit('toggle-visit')">
        <i v-if="member.redemptionActionInProgress"
           class="fa-solid fa-spinner fa-spin"></i>
        <template v-else>
            <i class="fa-solid fa-fw fa-check btn__child--hide-hover"></i>
            <i class="fa-solid fa-fw fa-redo btn__child--show-hover"></i>
        </template>
        <span>{{ l('MEMBERSHIP_DETAILS.UNDO_ADMISSION_BTN') }}</span>
    </button>
</template>

<script>
/**
 * Button to (un)admit a single member on a membership.
 * Note that this doesn't actually call anything. It only renders a button and emits a toggle-visit event when clicked.
 */
export default {
    props: {
        /**
         * @type {Member}
         */
        member: {
            type: Object,
            required: true,
        },

        /**
         * @type {Membership}
         */
        membership: {
            type: Object,
            required: true,
        },
    },

    emits: ['toggle-visit'],
};
</script>
